import React from "react";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Card, DescriptionCardHeading, FormLayout, FormLayoutSectionFormatProps} from "peggirkit";
import {slimCardFormLayoutProps} from "@widgets/layout/formLayout/FormLayout";
import FormLayoutSection from "peggirkit/dist/components/Form/Layout/LayoutSection/FormLayoutSection";
import {FormattedMessage, useIntl} from "react-intl";
import {SetFeaturedProductProps} from "@pages/authenticated/admin/products/FeaturedProduct";
import FeaturedProductDetailsForm from "@widgets/featuredProducts/editor/card/FeaturedProductDetailsForm";

type Props = SetFeaturedProductProps & {
    initialLoading: boolean,
    restaurantId: number,
};


const EditFeaturedProductCard = ({featuredProduct, setFeaturedProduct, initialLoading, restaurantId}: Props) => {
    const intl = useIntl();

    return (
        <Card
            header={
                <CardHeader>
                    <DescriptionCardHeading
                        title={intl.formatMessage({id: "details"})}
                        description={intl.formatMessage({id: "viewOrEditFeaturedProduct"})}
                    />
                </CardHeader>
            }
        >
            <FormLayout {...slimCardFormLayoutProps}>
                {(layoutProps: FormLayoutSectionFormatProps) => (
                    <>
                        <FormLayoutSection
                            {...layoutProps}
                            title={<FormattedMessage id={"general"}/>}
                            description={<FormattedMessage id={"featuredProductEditDescription"}/>}
                            noBorder
                            noPadding
                        >
                            <FeaturedProductDetailsForm
                                setFeaturedProduct={setFeaturedProduct}
                                featuredProduct={featuredProduct}
                                initialLoading={initialLoading}
                                restaurantId={restaurantId}
                            />
                        </FormLayoutSection>
                    </>
                )}
            </FormLayout>
        </Card>
    );
};

export default EditFeaturedProductCard;